var React = require('react');

function Ios (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.6241 7.122C10.7481 7.122 9.39206 6.126 7.96406 6.162C6.08006 6.186 4.35206 7.254 3.38006 8.946C1.42406 12.342 2.87606 17.358 4.78406 20.118C5.72006 21.462 6.82406 22.974 8.28806 22.926C9.69206 22.866 10.2201 22.014 11.9241 22.014C13.6161 22.014 14.0961 22.926 15.5841 22.89C17.0961 22.866 18.0561 21.522 18.9801 20.166C20.0481 18.606 20.4921 17.094 20.5161 17.01C20.4801 16.998 17.5761 15.882 17.5401 12.522C17.5161 9.714 19.8321 8.37 19.9401 8.31C18.6201 6.378 16.5921 6.162 15.8841 6.114C14.0361 5.97 12.4881 7.122 11.6241 7.122ZM14.7441 4.29C15.5241 3.354 16.0401 2.046 15.8961 0.75C14.7801 0.798 13.4361 1.494 12.6321 2.43C11.9121 3.258 11.2881 4.59 11.4561 5.862C12.6921 5.958 13.9641 5.226 14.7441 4.29Z","fill":"white"}));
}

Ios.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Ios;

Ios.default = Ios;
